<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New Sub Segment {{ (inputName) ? (" - " + this.inputName) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4">View Sub Segment - {{this.inputName}}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit Sub Segment - {{this.inputName}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <form id="form-proper">
            <div>
                <base-input alternative="" label="Code" placeholder="" v-model="sub_segment.code" input-classes="form-control"/>
                <base-input alternative="" label="Name" placeholder="" v-model="sub_segment.name" input-classes="form-control" required />
                <base-input alternative="" label="Reference Code" placeholder="" v-model="sub_segment.ref_code" input-classes="form-control" required />

                <base-input alternative="" label="Remark">
                    <textarea rows="4" class="form-control" v-model="sub_segment.remark" />
                </base-input>
                <base-input label="Pos Transaction Type" required>
                    <div class="form-group row">
                        <div class="col-sm-6">
                            <input type="text" class="form-control" v-model="posTransTypeName" disabled>
                        </div>
                        <div class="col-sm-6">
                            <autocomplete
                                ref="autocomplete"
                                placeholder="Search POS Transaction Type"
                                :source="posTransTypeEndPoint"
                                input-class="form-control"
                                results-property="data"
                                :results-display="formattedDisplay"
                                :request-headers="authHeaders"
                                @selected="getSelectedTransType"
                                :disableInput='isPosTransTypeDisabled'>
                            </autocomplete>
                        </div>
                    </div>
                </base-input>
                <base-input alternative="" label="Allowed Payment Types"  input-classes="form-control">
                    <p style="text-indent: 5px; font-size: 11px;">At least one payment type should be selected (no payment type selected by default)</p>
                    <a-select
                        class="mb-5"
                        v-model="sub_segment.allowed_payment_types_id"
                        mode="multiple"
                        style="width: 100%"
                        placeholder="Select Payment Types"
                        optionFilterProp="children"
                        @search="handlePaymentTypeSearch"
                        @change="getSelectedPaymentType"
                        :disabled="viewMode"
                        :filter-option="false"
                        :not-found-content="fetching ? undefined : null"
                        show-search
                        allowClear
                        >
                            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                            <a-select-option v-for="payment in payment_types"
                                :key="payment.id"
                                :value="payment.id"
                                :disabled="payment.disabled">{{ payment.name }}
                            </a-select-option>
                    </a-select>
                </base-input>
            </div>

            <div v-if="this.$attrs.viewMode != true">
                <div  v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button> 
                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>

        </form>

    </div>
    
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    
    import { mapState, mapActions } from 'vuex'
    import secureStorage from '../../controllers/secureStorage.js'
    import Autocomplete from 'vuejs-auto-complete'
    var component_x;
    export default {
        components: {
            Autocomplete
        },
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType', 'publicUrl']),
        },
        mounted: async function () {
            const systemModule = await HTTPRequest.getRequest(this.endPoint + "system_modules/Pos Sub Segment?field_name=name" , null)
            const systemModuleId = systemModule.id
            const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + systemModuleId + '?field_name=system_module_id' , null)

            if(this.isJsonString(accSystemModuleRequest.meta) == true){ 
             const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
             if(accSystemModule != null){
                 if(accSystemModule.form_mode != undefined){
                     this.customFormMode = accSystemModule.form_mode
                 }
                 if(accSystemModule.customized_forms != undefined){
                     this.customForm = accSystemModule.customized_forms
                 }
             }
            }

           if(this.serverType == 'branch' || this.$attrs.viewMode == true){
                let form = document.getElementById("form-proper")
                let elements = form.elements;
                for (let i = 0, len = elements.length; i < len; ++i) {
                    elements[i].readOnly = true;
                }
            }
            const posTransType = await HTTPRequest.getRequest(this.endPoint + 'pos_transaction_types', null)
            this.pos_trans_type = posTransType.data;
            
            this.payment_types.push({id: 0, name: ' All Payment Types'})
            // this.getPaymentTypes();

            component_x = this
            if (component_x.profileId > 0){
                let sub_segment_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_sub_segments/' + component_x.profileId, null)
                if(sub_segment_data == undefined){
                    component_x.$router.go()
                } else {
                    if(sub_segment_data["error"] == undefined){
                        component_x.sub_segment = sub_segment_data
                        component_x.inputName = sub_segment_data["name"]
                        component_x.inputCode = sub_segment_data["code"]
                        component_x.posTransTypeName = sub_segment_data["pos_transaction_type_name"]

                        if(this.sub_segment.all_payments == null) {
                            this.sub_segment.allowed_payment_types_id = []
                        } else if (this.sub_segment.all_payments == 1) {
                            this.sub_segment.allowed_payment_types_id = [this.allPaymentTypeId]
                        } else {
                            this.sub_segment.allowed_payment_types_id = this.sub_segment.allowed_payment_types_id
                        } 

                        this.sub_segment.allowed_payment_types_id.forEach(async (value) => {
                            if (value !== this.allPaymentTypeId){
                                let payment_type = await HTTPRequest.getRequest(component_x.endPoint + 'payment_types/' + value, null)
                                this.payment_types.push({
                                    id: payment_type.id,
                                    name: payment_type.name,
                                    disabled: false
                                })
                            }
                        })
                    } else {
                        this.errors = sub_segment_data["error"].split(",");
                    } 
                }
            } 

            this.dynamicFormKey++;
        },
        data() {
            this.handlePaymentTypeSearch = _.debounce(this.handlePaymentTypeSearch, 800)
            return {
                inputName: '',
                inputCode: '',
                errors: [],
                sub_segment: {},
                payment_types: [],
                pos_trans_type: [],
                posTransTypeName : '',
                isPosTransTypeDisabled: false,
                isPaymentTypeDisabled: false,
                authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
                viewMode: this.$attrs.viewMode, 
                allPaymentTypeId: 0,
                fetching: false,
                lastFetchId: 0
            }
        },
        methods: {
            updateSettings(newFormSettings, settingsGrouping, errors){
                let formSettingsCopy = this.bagger
                let mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
                this.formErrors = errors
                if(this.customFormMode == 3) {
                    this.errors = errors
                }
                this.bagger = mergedHash
            },
            isJsonString(str) {
                try {
                    let json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },
            posTransTypeEndPoint(input){
                return this.endPoint + '/pos_transaction_types?name=' + input;
            },
            getSelectedPaymentType(value){
                this.payment_types = this.payment_types.map((payment, i) => {
                    if (this.sub_segment.allowed_payment_types_id.includes(this.allPaymentTypeId)) {
                        if(payment.id == this.allPaymentTypeId){
                             this.sub_segment.allowed_payment_types_id = [this.allPaymentTypeId] // All Payment Types
                            payment.disabled = false; //enable All Payment Type option
                        } else {
                            payment.disabled = true; //disable options other than All Payment Type
                        }
                    } else {
                        payment.disabled = false; //enable all payment_types
                    }
                    return payment;
                });
            },
            getSelectedTransType(group){
                this.posTransTypeName = group.display;
                this.sub_segment.pos_transaction_type_id = group.value;
            },
            formattedDisplay (result) {
                return result.name + ' [' + result.code + ']';
            },
            validateForm(){
                this.errors = []
                // this.errors.push(ValidateField.required('Code', this.sub_segment.code));
                this.errors.push(ValidateField.required('Name', this.sub_segment.name));
                this.errors.push(ValidateField.required('POS Transaction Type', this.sub_segment.pos_transaction_type_id));
                this.errors.push(ValidateField.required('Reference Code', this.sub_segment.ref_code));


                this.errors.push(ValidateField.charMinAndMax('Code', this.sub_segment.code, 1, 15));
                this.errors.push(ValidateField.charMinAndMax('Name', this.sub_segment.name, 0, 200));

                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
                
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            handlePaymentTypeSearch (value) {
                this.fetching = true
                this.lastFetchId += 1;
                const fetchId = this.lastFetchId;

                fetch(this.endPoint + `payment_types?name=${value}`, {
                    headers: {
                    "Content-Type": "application/json",
                    "Authorization": 'Bearer ' + secureStorage.getItem("accessToken"), 
                    "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"
                    }
                })
                .then(res => res.json())
                .then(res => {
                    if (fetchId !== this.lastFetchId) {
                        // for fetch callback order
                        return;
                    }
                    
                    this.payment_types = res.data.map(value => {
                        return {
                            id: value.id,
                            name: value.name,
                            disabled: false 
                        }
                    })

                    this.payment_types.unshift({id: 0, name: ' All Payment Types'})
                    this.fetching = false
                })
            },
            create: async function (){
                 if (!this.validateForm()){
                    if (this.sub_segment.code != undefined)
                        this.sub_segment.code = this.sub_segment.code.trim()
                    if (this.sub_segment.name != undefined)
                        this.sub_segment.name = this.sub_segment.name.trim()
                    if (this.sub_segment.remark != undefined)
                        this.sub_segment.remark = this.sub_segment.remark.trim()
                    this.sub_segment.status = 'A'
                    
                    if (this.sub_segment.allowed_payment_types_id == undefined || this.sub_segment.allowed_payment_types_id.length == 0){
                        this.sub_segment.all_payments = null
                        this.sub_segment.allowed_payment_types_id = null
                    } else if (this.sub_segment.allowed_payment_types_id.includes(0)){
                        this.sub_segment.all_payments = 1
                        this.sub_segment.allowed_payment_types_id = null
                    } else {
                        this.sub_segment.all_payments = 0
                    }

                    let sub_segment_payload = { sub_segment: this.sub_segment }

                    let post_request = await HTTPRequest.postRequest(this.endPoint + 'pos_sub_segments', null, sub_segment_payload)
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(","); 
                        }
                    }
                } 
            },
            update: async function (){
                if(!this.validateForm()){
                    if (this.sub_segment.code != undefined)
                        this.sub_segment.code = this.sub_segment.code.trim()
                    if (this.sub_segment.name != undefined)
                        this.sub_segment.name = this.sub_segment.name.trim()
                    if (this.sub_segment.remark != undefined)
                        this.sub_segment.remark = this.sub_segment.remark.trim()
                    let status = (this.sub_segment.status == null) ? "A" : this.sub_segment.status
                    this.sub_segment.status = status

                    if (this.sub_segment.allowed_payment_types_id == undefined || this.sub_segment.allowed_payment_types_id.length == 0){
                        this.sub_segment.all_payments = null
                        this.sub_segment.allowed_payment_types_id = null
                    } else if (this.sub_segment.allowed_payment_types_id.includes(0)){
                        this.sub_segment.all_payments = 1
                        this.sub_segment.allowed_payment_types_id = null
                    } else {
                        this.sub_segment.all_payments = 0
                    } 

                    let editPayload = { sub_segment : this.sub_segment }
                    let put_request = await HTTPRequest.putRequest(this.endPoint + 'pos_sub_segments/' + this.profileId, null, editPayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            },
        },
    }
</script>